import { Card, CardBody, CardImg, CardTitle } from 'reactstrap';
import LoadingSpiner from '../components/LoadingSpiner';

import produitImage from './../../assets/images/product.png';
import { useDashboardStats } from '../../Api/queriesDashboard';
import { useNavigate } from 'react-router-dom';

export default function TotalProduit() {
  const {
    data: stats,
    isLoading: statsLoading,
    error: statsError,
  } = useDashboardStats();

  const navigate = useNavigate();

  const handleNavigate = () => {
    return navigate('/produits');
  };

  return (
    <div onClick={() => handleNavigate()} style={{ cursor: 'pointer' }}>
      {statsLoading && <LoadingSpiner />}
      {!statsError && !statsLoading && (
        <Card
          style={{
            height: '180px',
            boxShadow: '1px 0px 10px rgba(1, 186, 186, 0.57)',
          }}
        >
          <CardImg
            src={produitImage}
            alt='product'
            style={{ height: '90px', objectFit: 'contain' }}
          />
          <CardBody>
            <CardTitle className='text-center'>
              <span className='text-info fs-5'>{stats?.produits?.total ?? 0}</span>
              <p>Produits</p>
            </CardTitle>
          </CardBody>
        </Card>
      )}
    </div>
  );
}
